import { render, staticRenderFns } from "./myView.vue?vue&type=template&id=55c32f20&scoped=true"
import script from "./myView.vue?vue&type=script&lang=js"
export * from "./myView.vue?vue&type=script&lang=js"
import style0 from "./myView.vue?vue&type=style&index=0&id=55c32f20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c32f20",
  null
  
)

export default component.exports